module.exports = __webpack_public_path__ + "static/img/logo3.f09f983.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo3.png
// module id = Nyh+
// module chunks = 6